<div class="institutional-settings-container">
  <!-- Header -->
  <div class="header">
    <h1>Institutional Email Management</h1>
  </div>

  <!-- Institutions List Section -->
  <div class="institutions-section">
    <h2>My Institutions</h2>
    <p class="section-description">Overview of institutions providing you with a license.</p>

    <div class="table-responsive" *ngIf="!isLoading() || institutions().length > 0">
      <table mat-table [dataSource]="institutions()" class="mat-elevation-z0 institutions-table">
        
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef> Institution </th>
          <td mat-cell *matCellDef="let element"> 
            <span class="institution-name">{{element.name}}</span>
          </td>
        </ng-container>

        <!-- Description Column -->
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef> Details </th>
          <td mat-cell *matCellDef="let element"> {{element.description || '-'}} </td>
        </ng-container>

        <!-- License Tier Column -->
        <ng-container matColumnDef="licenseTier">
          <th mat-header-cell *matHeaderCellDef> License </th>
          <td mat-cell *matCellDef="let element"> 
            <span class="license-badge" [class.professional]="element.licenseTier?.toLowerCase().includes('pro')" [class.essential]="element.licenseTier?.toLowerCase().includes('essential')">
              {{element.licenseTier}}
            </span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell no-data" [attr.colspan]="displayedColumns.length">
            No institutions found. Add an institutional email below to join one.
          </td>
        </tr>
      </table>
    </div>
    
    <div class="loading-indicator" *ngIf="isLoading() && institutions().length === 0">
      <mat-spinner diameter="30"></mat-spinner>
    </div>
  </div>

  <mat-divider class="section-divider"></mat-divider>

  <!-- Add New Email Section -->
  <div class="add-email-section">
    <h2>Add New Email Address</h2>

    <form [formGroup]="addEmailForm" (ngSubmit)="addInstitutionalEmail()" class="add-email-form">
      <div class="email-input-group">
        <div class="input-container">
          <input
            type="text"
            formControlName="username"
            placeholder="username"
            class="username-input">
          <span class="at-symbol">&#64;</span>
          <input
            type="text"
            formControlName="domain"
            placeholder="institution.org"
            class="domain-input">
        </div>

        <button
          type="submit"
          class="add-btn"
          [disabled]="!addEmailForm.valid || isLoading()">
          <span *ngIf="!isLoading()">Add Email</span>
          <span *ngIf="isLoading()">Adding...</span>
        </button>
      </div>

      <!-- Registered Emails List -->
      <div class="verification-section" *ngFor="let email of registeredEmailsList()">
        <div class="pending-email-info">
          <span class="pending-email">{{ email.emailAddress }}</span>
          <span class="pending-status" [class.verified]="email.isVerified">
            {{ email.isVerified ? 'Verified' : 'Pending verification' }}
          </span>
        </div>

        <div class="action-buttons" style="display: flex; gap: 8px; align-items: center;">
          <button
            *ngIf="!email.isVerified"
            type="button"
            class="verify-btn"
            (click)="sendVerificationEmail(email.emailAddress)"
            [disabled]="isLoading()">
            Verify
          </button>

          <button
            type="button"
            mat-icon-button
            color="warn"
            (click)="removeInstitutionalEmail(email.emailAddress)"
            [disabled]="isLoading()"
            matTooltip="Remove email">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
        
        <!-- Verification info notice for unverified emails -->
        <div class="verification-info-notice" *ngIf="!email.isVerified" style="margin-top: 8px; padding: 8px 12px; background: #fff3cd; border-left: 3px solid #ffc107; border-radius: 4px; font-size: 0.85rem; color: #856404;">
          <mat-icon style="font-size: 16px; height: 16px; width: 16px; vertical-align: middle; margin-right: 4px;">info</mat-icon>
          <span>Institutional license for this domain will only be activated once this email is verified.</span>
        </div>
      </div>
      
      <div class="verification-section" *ngIf="pendingEmail() && registeredEmailsList().length === 0">
         <div class="pending-email-info">
          <span class="pending-email">{{ pendingEmail() }}</span>
          <span class="pending-status">Pending update...</span>
        </div>
      </div>
    </form>
  </div>
</div>
